export const DIGESTIVE_NAMES = {
  "Large_Intestine": { english: "Large Intestine (Colon)", latin: "Intestinum Crassum" },
  "Stomach": { english: "Stomach (Gaster)", latin: "Gaster (Ventriculus)" },
  "Pancreas_tail": { english: "Tail of Pancreas", latin: "Cauda Pancreatis" },
  "Pancreas__Head": { english: "Head of Pancreas", latin: "Caput Pancreatis" },
  "Pancreas__Body": { english: "Body of Pancreas", latin: "Corpus Pancreatis" },
  "Small_Intestine": { english: "Small Intestine", latin: "Intestinum Tenue" },
  "Stomach_cap2": { english: "Fundus of Stomach", latin: "Fundus Gastricus" },
  "Pyloric_Sphincter_valve": { english: "Pyloric Sphincter", latin: "Sphincter Pylori" },
  "Duodenum": { english: "Duodenum", latin: "Duodenum" },
  "Stomach_cap": { english: "Body of Stomach", latin: "Corpus Gastricum" },
  "Ducts_A": { english: "Common Bile Duct", latin: "Ductus Choledochus" },
  "Ducts_B": { english: "Pancreatic Duct (Duct of Wirsung)", latin: "Ductus Pancreaticus" },
  "Esophagus_": { english: "Esophagus", latin: "Oesophagus" },
  "Gall_bladder": { english: "Gallbladder", latin: "Vesica Biliaris" },
  "Left_Lobe": { english: "Left Lobe of Liver", latin: "Lobus Hepatis Sinister" },
  "Right_Lobe": { english: "Right Lobe of Liver", latin: "Lobus Hepatis Dexter" },
  "Gingiva": { english: "Gingiva (Gums)", latin: "Gingiva" },
  "Salivary_duct": { english: "Parotid Duct (Stensen's Duct)", latin: "Ductus Parotideus" },
  "Salivary_gland": { english: "Parotid Gland", latin: "Glandula Parotidea" },
  "Oral_cavity": { english: "Oral Cavity", latin: "Cavitas Oris" },
  "Tongue": { english: "Tongue", latin: "Lingua" },
  "Nasopharynx": { english: "Nasopharynx", latin: "Pars Nasalis Pharyngis" },
  "Lesser_omentum": { english: "Lesser Omentum", latin: "Omentum Minus" },
  "Ligament_Treitz": { english: "Suspensory Ligament of the Duodenum (Ligament of Treitz)", latin: "Ligamentum Suspensorium Duodeni" },
  "Greater_omentum": { english: "Greater Omentum", latin: "Omentum Majus" },
  "Geniohyoid": { english: "Geniohyoid Muscle", latin: "Musculus Geniohyoideus" },
  "Mylohyoid": { english: "Mylohyoid Muscle", latin: "Musculus Mylohyoideus" },
  "Styloglossus": { english: "Styloglossus Muscle", latin: "Musculus Styloglossus" },
  "Palatoglossus": { english: "Palatoglossus Muscle", latin: "Musculus Palatoglossus" },
  "Hyoglossus": { english: "Hyoglossus Muscle", latin: "Musculus Hyoglossus" },
  "Genioglossus": { english: "Genioglossus Muscle", latin: "Musculus Genioglossus" },
  "Anal_sphincter_external_001": { english: "External Anal Sphincter", latin: "Musculus Sphincter Ani Externus" },
  "Anal_sphincter_internal_001": { english: "Internal Anal Sphincter", latin: "Musculus Sphincter Ani Internus" },
  "Teeth_Incisor_central_24": { english: "Mandibular Left Central Incisor (#24)", latin: "Dens Incisivus Centralis Inferior Sinister" },
  "Teeth_Incisor_central_09": { english: "Maxillary Left Central Incisor (#9)", latin: "Dens Incisivus Centralis Superior Sinister" },
  "Teeth_Incisor_central_08": { english: "Maxillary Right Central Incisor (#8)", latin: "Dens Incisivus Centralis Superior Dexter" },
  "Teeth_Incisor_central_025": { english: "Mandibular Right Central Incisor (#25)", latin: "Dens Incisivus Centralis Inferior Dexter" },
  "Teeth_Incisor_lateral_10": { english: "Maxillary Left Lateral Incisor (#10)", latin: "Dens Incisivus Lateralis Superior Sinister" },
  "Teeth_Incisor_lateral_23": { english: "Mandibular Left Lateral Incisor (#23)", latin: "Dens Incisivus Lateralis Inferior Sinister" },
  "Teeth_Incisor_lateral_07": { english: "Maxillary Right Lateral Incisor (#7)", latin: "Dens Incisivus Lateralis Superior Dexter" },
  "Teeth_Incisor_lateral_026": { english: "Mandibular Right Lateral Incisor (#26)", latin: "Dens Incisivus Lateralis Inferior Dexter" },
  "Teeth_Canine_22": { english: "Mandibular Left Canine (#22)", latin: "Dens Caninus Inferior Sinister" },
  "Teeth_Canine_11": { english: "Maxillary Left Canine (#11)", latin: "Dens Caninus Superior Sinister" },
  "Teeth_Canine_06": { english: "Maxillary Right Canine (#6)", latin: "Dens Caninus Superior Dexter" },
  "Teeth_Canine_027": { english: "Mandibular Right Canine (#27)", latin: "Dens Caninus Inferior Dexter" },
  "Teeth_Premolar_first_21": { english: "Mandibular Left First Premolar (#21)", latin: "Dens Premolaris Primus Inferior Sinister" },
  "Teeth_Premolar_first_12": { english: "Maxillary Left First Premolar (#12)", latin: "Dens Premolaris Primus Superior Sinister" },
  "Teeth_Premolar_first_05": { english: "Maxillary Right First Premolar (#5)", latin: "Dens Premolaris Primus Superior Dexter" },
  "Teeth_Premolar_first_28": { english: "Mandibular Right First Premolar (#28)", latin: "Dens Premolaris Primus Inferior Dexter" },
  "Teeth_Premolar_second_20": { english: "Mandibular Left Second Premolar (#20)", latin: "Dens Premolaris Secundus Inferior Sinister" },
  "Teeth_Premolar_second_13": { english: "Maxillary Left Second Premolar (#13)", latin: "Dens Premolaris Secundus Superior Sinister" },
  "Teeth_Premolar_second_04": { english: "Maxillary Right Second Premolar (#4)", latin: "Dens Premolaris Secundus Superior Dexter" },
  "Teeth_Premolar_second_29": { english: "Mandibular Right Second Premolar (#29)", latin: "Dens Premolaris Secundus Inferior Dexter" },
  "Teeth_Molar_first_14": { english: "Maxillary Left First Molar (#14)", latin: "Dens Molaris Primus Superior Sinister" },
  "Teeth_Molar_first_19": { english: "Mandibular Left First Molar (#19)", latin: "Dens Molaris Primus Inferior Sinister" },
  "Teeth_Molar_first_30": { english: "Mandibular Right First Molar (#30)", latin: "Dens Molaris Primus Inferior Dexter" },
  "Teeth_Molar_first_03": { english: "Maxillary Right First Molar (#3)", latin: "Dens Molaris Primus Superior Dexter" },
  "Teeth_Molar_second_18": { english: "Mandibular Left Second Molar (#18)", latin: "Dens Molaris Secundus Inferior Sinister" },
  "Teeth_Molar_second_15": { english: "Maxillary Left Second Molar (#15)", latin: "Dens Molaris Secundus Superior Sinister" },
  "Teeth_Molar_second_31": { english: "Mandibular Right Second Molar (#31)", latin: "Dens Molaris Secundus Inferior Dexter" },
  "Teeth_Molar_second_02": { english: "Maxillary Right Second Molar (#2)", latin: "Dens Molaris Secundus Superior Dexter" },
  "Teeth_Molar_third_32": { english: "Mandibular Right Third Molar — Wisdom Tooth (#32)", latin: "Dens Molaris Tertius Inferior Dexter (Dens Serotinus)" },
  "Teeth_Molar_third_01": { english: "Maxillary Right Third Molar — Wisdom Tooth (#1)", latin: "Dens Molaris Tertius Superior Dexter (Dens Serotinus)" },
  "Teeth_Molar_third_17": { english: "Mandibular Left Third Molar — Wisdom Tooth (#17)", latin: "Dens Molaris Tertius Inferior Sinister (Dens Serotinus)" },
  "Teeth_Molar_third_16": { english: "Maxillary Left Third Molar — Wisdom Tooth (#16)", latin: "Dens Molaris Tertius Superior Sinister (Dens Serotinus)" },
  "Liver_Veins": { english: "Hepatic Veins", latin: "Venae Hepaticae" },
  "Liver_arteries": { english: "Hepatic Artery Proper", latin: "Arteria Hepatica Propria" }
};

const DIGESTIVE_KEYS = Object.keys(DIGESTIVE_NAMES);

function fuzzyMatch(name) {
  if (!name) return null;
  if (DIGESTIVE_NAMES.hasOwnProperty(name)) return name;

  const normalized = name.trim();
  for (const key of DIGESTIVE_KEYS) {
    if (key.trim() === normalized) return key;
  }

  const lower = normalized.toLowerCase().replace(/\s+/g, ' ');
  for (const key of DIGESTIVE_KEYS) {
    if (key.toLowerCase().replace(/\s+/g, ' ') === lower) return key;
  }

  return null;
}

export function resolveDigestiveName(mesh) {
  if (!mesh) return null;

  const meshName = mesh.name || '';
  const matName = mesh.material?.name || '';
  const parentName = mesh.parent?.name || '';

  if (meshName) { const match = fuzzyMatch(meshName); if (match) return match; }
  if (matName) { const match = fuzzyMatch(matName); if (match) return match; }
  if (parentName) { const match = fuzzyMatch(parentName); if (match) return match; }

  let ancestor = mesh.parent;
  while (ancestor) {
    if (ancestor.name) { const match = fuzzyMatch(ancestor.name); if (match) return match; }
    ancestor = ancestor.parent;
  }

  if (meshName.length > 0) return meshName;
  if (matName.length > 0) return matName;

  return null;
}

export function getDigestiveInfo(meshName) {
  if (!meshName) return { english: "Unknown Structure", latin: "Incertum" };

  const matched = fuzzyMatch(meshName);
  if (matched && DIGESTIVE_NAMES[matched]) return DIGESTIVE_NAMES[matched];

  let clean = meshName.replace(/_/g, ' ').replace(/\d+$/, '').trim();
  clean = clean.replace(/\bL\b/g, 'Left').replace(/\bR\b/g, 'Right');
  return { english: clean, latin: clean };
}
